import type { ReactNode } from 'react';

import type { themeVars } from '@shieldpay/theme-provider-ui/theme';

import { Text } from '../text/text';

import * as styles from './label.css';

// We could just list some string literals here, but the thinking
// is that picking from an existing type will show errors quicker
export type LabelVariant = keyof Pick<
  typeof themeVars.typography.variant,
  'caption' | 'body150'
>;

export interface LabelProps {
  htmlFor?: string;
  children: ReactNode;
  disabled?: boolean;
  variant?: LabelVariant;
  id?: string;
  'data-testid'?: string;
}

export const Label = ({
  htmlFor,
  children,
  id,
  disabled = false,
  variant = 'caption',
  'data-testid': testId,
}: LabelProps) => (
  <Text
    Component="label"
    htmlFor={htmlFor}
    id={id}
    variant={variant}
    className={disabled ? styles.disabled : undefined}
    data-testid={testId}
  >
    {children}
  </Text>
);
